export const PERSONA_DELETE_MESSAGES = {
  missing: "This persona no longer exists. Refresh the page to update the list.",
  denied: "You don't have permission to delete this persona.",
  status: "Only failed persona generations can be deleted.",
  active: "Narrative work is still in progress for this persona. Wait for it to finish, then try again.",
  starter: "Starter persona work is still in progress. Wait for it to finish or discard it before deleting this persona.",
  campaign: "Video Express work is still in progress for this persona. Wait for it to finish or pause it before deleting this persona.",
  required: "This persona is still required by saved work. Choose a different persona for that work before trying again.",
  unexpected: "We couldn't delete this persona right now. Please try again.",
  auth: "Please sign in again before deleting this persona.",
} as const;

export class PersonaDeletionError extends Error {
  constructor(public status: number, public code: keyof typeof PERSONA_DELETE_MESSAGES) {
    super(PERSONA_DELETE_MESSAGES[code]);
  }
}

// Local allowlist: never display an arbitrary server body or shared HTTP error.
export function personaDeletionMessage(error: unknown): string {
  if (!(error instanceof Error)) return PERSONA_DELETE_MESSAGES.unexpected;
  return Object.values(PERSONA_DELETE_MESSAGES).find(message => message === error.message)
    ?? PERSONA_DELETE_MESSAGES.unexpected;
}
